import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PlusCircle, Eye } from "react-feather";
import MasterDetailListShell from "../../../../components/layout/MasterDetailListShell";
import MasterDetailRow from "../../../../components/layout/MasterDetailRow";
import StatusBadge from "../../../../components/common/StatusBadge";
import { PETTY_CASH_RECONCILIATION_STATUS_CLASS, PETTY_CASH_RECONCILIATION_STATUS_LABEL } from "../../pettyCashStatusMaps";
import { useListPettyCashReconciliationsQuery } from "../../pettyCashApi";
import { useCanReconcile } from "../../usePettyCashPermissions";
import { useBranchFilter } from "../../../branchFilter/useBranchFilter";
import { paths } from "../../../../routes/paths";

const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "SUBMITTED", label: "Submitted" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
];

const money = (n) => Number(n || 0).toFixed(2);

const ReconciliationCompactList = () => {
  const canCreate = useCanReconcile();
  const navigate = useNavigate();
  const { recordGuid: selectedRecordGuid } = useParams();
  const [status, setStatus] = useState("");
  const { selectedBranchId } = useBranchFilter();

  const { data, isLoading } = useListPettyCashReconciliationsQuery({
    branchId: selectedBranchId ?? undefined,
    status: status || undefined,
    pageSize: 200,
  });

  const items = data?.items || [];

  return (
    <MasterDetailListShell
      title="Petty Cash Reconciliations"
      addButton={
        canCreate && (
          <button type="button" className="btn btn-added" onClick={() => navigate(paths.pettyCashReconciliationNew)}>
            <PlusCircle className="me-2" size={16} />
            New Reconciliation
          </button>
        )
      }
      filters={
        <select className="form-control form-control-sm" value={status} onChange={(e) => setStatus(e.target.value)}>
          {STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      }
      isLoading={isLoading}
      emptyLabel="No reconciliations match these filters."
      items={items}
      getKey={(r) => r.recordGuid}
      resetKey={`${status}|${selectedBranchId}`}
      renderItem={(r) => {
        const isSelected = String(r.recordGuid) === String(selectedRecordGuid);
        return (
          <MasterDetailRow
            isSelected={isSelected}
            onClick={() => navigate(paths.pettyCashReconciliationDetail(r.recordGuid))}
            avatarLabel={(r.submittedByName || "?").trim().slice(0, 2).toUpperCase()}
            title={<>{r.fundName} <span className="text-muted ms-1">{new Date(r.reconciliationDate).toLocaleDateString()}</span></>}
            subtitle={<>Diff: {money(r.difference)} &middot; {r.branchCode}</>}
            badge={
              <span className="me-2">
                <StatusBadge status={r.status} classMap={PETTY_CASH_RECONCILIATION_STATUS_CLASS} labelMap={PETTY_CASH_RECONCILIATION_STATUS_LABEL} />
              </span>
            }
            actions={
              <button
                type="button"
                className="btn btn-link p-1"
                title="View"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(paths.pettyCashReconciliationDetail(r.recordGuid));
                }}
              >
                <Eye size={15} />
              </button>
            }
          />
        );
      }}
    />
  );
};

export default ReconciliationCompactList;
